import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigma = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"type": "page",
			"properties": {
				"title": [
					[
						"Работа в Figma"
					]
				]
			},
			"content": [
				"789f328d-8ce0-4d12-9843-8f0a3041d273",
				"483bd224-8ef6-48d7-ac75-8937fc2674fd",
				"b2d017a9-f1de-430a-a5a8-cfc891522eba",
				"cc2cdcce-09ef-4d24-afa2-f0c002e95de1",
				"040a6cd6-8422-4cfe-b6ad-15552163f574",
				"c4509627-0963-46f7-b241-75cf7e21b48f",
				"282f2e08-767b-4a34-bf28-bab4c5200f0b",
				"60a2ce12-eede-4504-b16b-d282ef6f3432",
				"9dc111af-a12b-4367-8794-3759c3fd7e20",
				"55497ed9-093a-4b71-89f2-0176fe950dfa",
				"cccf741e-a713-4a7e-8a01-654dde02fd35",
				"313df6ca-eed8-4dc2-b9dc-ab569104ff1a"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c59a69b2-1701-4b2a-9fd2-da2f29b58ab5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"acca5b80-a4ce-4ef5-b0a0-8e6ac5700c4b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "789f328d-8ce0-4d12-9843-8f0a3041d273",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "483bd224-8ef6-48d7-ac75-8937fc2674fd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Figma — основной инструмент в нашей команде, который позволяет дизайнерам работать в одном пространстве. Чтобы процесс работы был комфортным и понятным, мы собрали в этом документе основные правила. Они структурируют подход к созданию макетов в Figma. Мы не требуем неукоснительного следования нашим правилам, но единый подход позволит сохранить консистентность внутри всего проекта. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4b6d1e79-5e32-4a93-ad80-4ab0e3a0515b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b2d017a9-f1de-430a-a5a8-cfc891522eba",
			"type": "image",
			"properties": {
				"size": [
					[
						"285.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c3ca91c8-7e7c-4061-a19f-37d4cb8383da/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c3ca91c8-7e7c-4061-a19f-37d4cb8383da/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.29333333333333333,
				"block_preserve_scale": true
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"file_ids": [
				"c3ca91c8-7e7c-4061-a19f-37d4cb8383da"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b2d017a9-f1de-430a-a5a8-cfc891522eba.png"
		},
		{
			"id": "cc2cdcce-09ef-4d24-afa2-f0c002e95de1",
			"type": "header",
			"properties": {
				"title": [
					[
						"Структура работы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "67bbfa75-0189-41fe-a139-002a75eccb78",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "040a6cd6-8422-4cfe-b6ad-15552163f574",
			"type": "text",
			"properties": {
				"title": [
					[
						"Создавая эту систему мы стремились ускорить интеграцию дизайнеров в наши продукты и создать среду для совместной работы. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8202dd98-a7a4-4604-af25-d9995b98e795",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c4509627-0963-46f7-b241-75cf7e21b48f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для поддержания правильного баланса между скоростью и открытостью мы расставили приоритеты согласно принципам:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ad4cf610-9244-46c0-a181-69cd5f6855cb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "282f2e08-767b-4a34-bf28-bab4c5200f0b",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Открытость",
						[
							[
								"b"
							]
						]
					],
					[
						". \nДизайнеры имеют полный доступ ко всем файлам и проектам. Мы учимся друг у друга и используем все возможности инструмента. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3d986bf0-5280-48c3-a924-281cbfcf2048",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "60a2ce12-eede-4504-b16b-d282ef6f3432",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Взаимоуважение.",
						[
							[
								"b"
							]
						]
					],
					[
						" \nДизайнеры уважают работу друг друга и не вносят изменений в чужие макеты без предупреждения. Лучше оставить комментарий, чем изменить дизайн."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ce66616-e3c1-43c5-9096-9cc0a89a01bb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9dc111af-a12b-4367-8794-3759c3fd7e20",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Системность.",
						[
							[
								"b"
							]
						]
					],
					[
						" \nФайлы и проекты имеют понятное название. В рабочих файлах должен быть порядок и есть очевидная структура. Экраны интерфейса собираются с помощью компонентов дизайн системы. Все цвета и типографика покрыты Variables."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "878a93fb-f24e-45a2-877e-bf0e73ee4756",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "55497ed9-093a-4b71-89f2-0176fe950dfa",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Управляемость",
						[
							[
								"b"
							]
						]
					],
					[
						". \nРазделяем большие продукты на части и работаем маленькими командами. Не нужно делать один проект для всего бизнес-юнита, разделите пространство Figma по продуктам."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ef9920b7-3c89-463c-b4f6-3dc57d497fc3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cccf741e-a713-4a7e-8a01-654dde02fd35",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Развитие",
						[
							[
								"b"
							]
						]
					],
					[
						". \nПроекты, файлы и команды не должны расти до гигантских размеров. Помимо того что большие файлы или библиотеки тормозят систему, в них еще сложно ориентироваться."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c9ca2c51-fd59-4b74-bc2e-0e55208042eb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "313df6ca-eed8-4dc2-b9dc-ab569104ff1a",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Автономность",
						[
							[
								"b"
							]
						]
					],
					[
						". \nКаждая команда может отходить от рекомендаций, тем самым мы признаем, что одно решение может не подходить всем."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "be4c6d2f-40f2-42aa-a560-414e74a7522c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "16b738c5-499f-42a0-baf4-cffb990a0b25",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Структура работы",
			"id": "cc2cdcce-09ef-4d24-afa2-f0c002e95de1"
		}
	]
}} />
);

export default NotionFigma;
